<template>
  <div class="member">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('member.memberInfo')"
      left-arrow
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <div class="main">
      <div class="header">
        <van-button
          v-if="!point"
          :color="sessionStorage.colorCode"
          round
          @click="show = true"
        >
          {{ $t("member.Login") }}
          <span class="icon">/</span>
          {{ $t("member.Register") }}
        </van-button>
        <van-button
          v-else
          :color="sessionStorage.colorCode"
          round
          @click="loginOut"
        >
          {{ $t("member.Logout") }}
        </van-button>
      </div>
      <div class="content">
        <div class="card">
          <span class="card_left">
            <p>{{ $t("member.AvailableBalance") }}</p>
            <p>
              ￥
              <span v-if="point">{{ point }}</span>
              <span v-else>- -</span>
            </p>
          </span>
        </div>
        <div class="recharge_title">{{ $t("member.RechargeAmount") }}</div>
        <div class="recharge">
          <div
            class="recharge_card"
            v-for="(item, key) in amountList"
            :key="key"
            :style="
              item.selected
                ? `border: 1px solid ${sessionStorage.colorCode}; background-color: ${rgba};`
                : ''
            "
            @click="selectBtn(item, key)"
          >
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="footer">
        <van-button
          class="okBtn"
          :color="sessionStorage.colorCode"
          round
          @click="RechargeBtn"
        >
          <van-icon size="35px" name="./static/img/placeOrder.png" />
        </van-button>
      </div>
      <div class="logs" v-if="logsList.length != 0">
        <div class="recharge_title">{{ $t("member.BalanceDetails") }}</div>
        <div class="cell" v-for="item in logsList" :key="item.order_id">
          <div class="cell_content">
            <div class="cell_left">
              {{ item.remark }}
            </div>
            <div
              class="cell_right"
              :style="item.symbol == '+' ? 'color: red;' : 'color: #999;'"
            >
              {{ item.symbol }}{{ item.real_point }}
            </div>
          </div>
        </div>
      </div>
      <!-- 会员登录/注册弹窗 -->
      <van-popup
        v-model="show"
        position="bottom"
        :style="{ height: '40%' }"
        style="border-radius: 10px 10px 0px 0px; z-index: 2001;"
      >
        <template>
          <div v-show="loginShow">
            <van-nav-bar
              :title="$t('member.MemberLogin')"
              :right-text="$t('member.Register')"
              left-arrow
              @click-left="show = false"
              @click-right="loginShow = false"
            />
            <div class="popup_content">
              <!-- 手机号 -->
              <van-field
                size="large"
                v-model="loginForm.phone"
                type="tel"
                left-icon="static/img/iphone_num.png"
                :placeholder="$t('ForgetPassword.inputPhone')"
              >
              </van-field>
              <!-- 密码 -->
              <van-field
                size="large"
                v-model="loginForm.password"
                @input="judgePassword"
                type="password"
                left-icon="static/img/Password.png"
                clearable
                :placeholder="$t('ForgetPassword.PleaseEnterThePassword')"
              />
            </div>
            <div class="popup_footer">
              <van-button
                class="loginBtn"
                :color="sessionStorage.colorCode"
                round
                @click="loginBtn"
              >
                OK
              </van-button>
            </div>
          </div>
        </template>
        <template>
          <div v-show="!loginShow">
            <van-nav-bar
              :title="$t('member.MemberRegistration')"
              :right-text="$t('member.Login')"
              left-arrow
              @click-left="show = false"
              @click-right="loginShow = true"
            />
            <div class="popup-info-main">
              <!-- 手机号 -->
              <van-field
                size="large"
                v-model="phone"
                type="tel"
                left-icon="static/img/iphone_num.png"
                :placeholder="$t('ForgetPassword.inputPhone')"
              >
                <!-- 区号 -->
                <template #label>
                  <div>
                    <el-select
                      v-model="areaName"
                      :placeholder="$t('ForgetPassword.areaName')"
                    >
                      <el-option
                        v-for="item in columns"
                        :key="item.id"
                        :label="'+' + item.acnumber"
                        :value="item.acnumber"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
                <!-- 获取验证码 -->
                <template #button>
                  <van-button
                    size="small"
                    color="#2f75f4"
                    :disabled="isSms"
                    @click.stop="sendCode"
                  >
                    {{ $t("ForgetPassword.SMS") }}
                  </van-button>
                </template>
              </van-field>
              <!-- 验证码 -->
              <van-field
                size="large"
                v-model="code"
                left-icon="static/img/Verification.png"
                :placeholder="$t('ForgetPassword.inputSMS')"
              >
              </van-field>
              <!-- 密码 -->
              <van-field
                size="large"
                v-model="password"
                @input="judgePassword"
                type="password"
                left-icon="static/img/Password.png"
                clearable
                :placeholder="$t('ForgetPassword.setNewPassword')"
              />
              <!-- 二次密码 -->
              <van-field
                size="large"
                v-model="repassword"
                @input="judgePassword"
                type="password"
                left-icon="static/img/Password.png"
                clearable
                :placeholder="$t('ForgetPassword.certainPassword')"
                :error-message="repasswordJudge"
              />
            </div>
            <div class="popup_footer">
              <van-button
                class="loginBtn"
                :color="sessionStorage.colorCode"
                round
                @click="registerBtn"
              >
                OK
              </van-button>
            </div>
          </div>
        </template>
      </van-popup>
      <!-- 付款方式弹窗 -->
      <van-popup v-model="payWrapper" position="bottom" round>
        <van-nav-bar
          :title="$t('member.ChoosePaymentMethod')"
          left-arrow
          @click-left="payWrapper = false"
        />
        <van-radio-group v-model="radio" @change="onChange">
          <van-cell-group>
            <template
              v-if="$i18n.locale == 'zh'"
              v-for="(pay, key) in payMethod"
            >
              <van-cell
                :title="pay.name_cn"
                clickable
                :data-name="pay.name_en"
                :key="key"
              >
                <van-radio
                  :checked-color="sessionStorage.colorCode"
                  slot="right-icon"
                  :name="pay.name_en"
                />
              </van-cell>
            </template>
            <template
              v-if="$i18n.locale == 'hk'"
              v-for="(pay, key) in payMethod"
            >
              <van-cell
                :title="pay.name_hk"
                clickable
                :data-name="pay.name_en"
                :key="key"
              >
                <van-radio
                  :checked-color="sessionStorage.colorCode"
                  slot="right-icon"
                  :name="pay.name_en"
                />
              </van-cell>
            </template>
            <template
              v-if="$i18n.locale == 'en'"
              v-for="(pay, key) in payMethod"
            >
              <van-cell
                :title="pay.name_en"
                clickable
                :data-name="pay.name_en"
                :key="key"
              >
                <van-radio
                  :checked-color="sessionStorage.colorCode"
                  slot="right-icon"
                  :name="pay.name_en"
                />
              </van-cell>
            </template>
          </van-cell-group>
          <div style="width: 100%; height: 50px">
            <van-button
              style="
              width: 90%;
              height: 35px;
              margin-left: 5%;
              margin-top: 7px;
              line-height: 35px;
            "
              :color="sessionStorage.colorCode"
              round
              @click="goPay()"
              >{{ $t("OrderDetail.goPay") }}</van-button
            >
          </div>
        </van-radio-group>
      </van-popup>
    </div>
    <div class="form" v-html="content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      storeId: "",
      amountList: [], // 充值金额
      show: false,
      isSms: false,
      smskey: "",
      loginShow: true,
      columns: [],
      radio: "",
      payWrapper: false,
      payMethod: [], // 支付方式
      // 登录信息
      loginForm: {
        phone: "",
        password: ""
      },
      // 注册信息
      areaName: 86,
      phone: "",
      code: "",
      password: "",
      repassword: "",
      repasswordJudge: "",
      rgba: "",
      content: "",
      point: null, // 余额
      logsList: [] // 余额明细
    };
  },
  mounted() {
    this.storeId = sessionStorage.getItem("storeId");
    this.getAceeghrr();
    this.getAreacode();
    this.getPayment();
    this.rgba = this.convertColorToRGBA(sessionStorage.colorCode);
    let list = this.rgba.split("");
    list[list.length - 1] = ", 0.5)"; // 半透明
    this.rgba = list.join("");
    // this.loginBtn();
    // this.getlogs();
  },
  methods: {
    onChange(val) {
      console.log(val);
    },
    // 颜色代码转RGBA格式
    convertColorToRGBA(color) {
      // 创建临时元素并设置其背景颜色为给定的颜色
      const tempElement = document.createElement("div");
      tempElement.style.backgroundColor = color;
      document.body.appendChild(tempElement);
      // 获取元素的计算样式
      const computedStyle = getComputedStyle(tempElement);
      // 从计算样式中提取颜色值
      const rgba = computedStyle.backgroundColor;
      // 删除临时元素
      document.body.removeChild(tempElement);
      return rgba;
    },
    // 选择充值金额
    selectBtn(item, index) {
      this.amountList.forEach(i => {
        i.selected = false;
      });
      item.selected = true;
      this.amountList.splice(index, 1, item);
    },
    // 二次密码校验
    judgePassword() {
      if (this.password == this.repassword) {
        this.repasswordJudge = "";
      } else {
        this.repasswordJudge = this.$t("ForgetPassword.repasswordJudge");
      }
    },
    // 获取充值金额列表
    getAceeghrr() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.code
        },
        url: this.$build + `/api/recharge/${this.storeId}/index`
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.amountList = res.data.data;
            this.amountList = this.amountList.filter(item => item.status == 1);
            this.amountList.forEach(item => {
              item.selected = false;
            });
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取验证码
    sendCode() {
      if (this.areacode && this.phone) {
        this.$axios({
          method: "post",
          url: this.$build + "/api/send",
          data: {
            area_code: this.areacode,
            phone: this.phone
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.isSms = true;
              this.smskey = res.data.success.key;
              const vm = this;
              setTimeout(function() {
                vm.isSms = false;
                console.log(1111111);
              }, 60000);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("ForgetPassword.message")
            });
          });
      } else {
        this.$toast(this.$t("ForgetPassword.inputAreaNameAndPhone"));
      }
    },
    // 获取区号
    getAreacode() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/areacode"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.columns = res.data.data;
            for (var i = 0; i < this.columns.length; i++) {
              if (this.getLangs == "en") {
                this.columns[i].text =
                  this.columns[i].acname_en +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              } else if (this.getLangs == "hk") {
                this.columns[i].text =
                  this.columns[i].acname_hk +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              } else if (this.getLangs == "zh") {
                this.columns[i].text =
                  this.columns[i].acname_cn +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              } else {
                this.columns[i].text =
                  this.columns[i].acname_en +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              }
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ForgetPassword.message")
          });
        });
    },
    // 假登录, 查看余额功能
    loginBtn() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.code
        },
        url: this.$build + "/api/member/surplus",
        data: {
          store_id: this.storeId,
          phone: this.loginForm.phone,
          password: this.loginForm.password
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.point = res.data.data.point;
            this.getlogs();
            this.show = false;
            // this.loginForm.phone = "";
            // this.loginForm.password = "";
          } else {
            this.$toast({
              type: "fail",
              message: "未注册账号"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getlogs() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.code
        },
        url: this.$build + "/api/member/logs",
        data: {
          store_id: this.storeId,
          phone: this.loginForm.phone,
          password: this.loginForm.password
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.logsList = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loginOut() {
      this.point = null;
      this.logsList = [];
      this.loginForm.phone = "";
      this.loginForm.password = "";
    },
    // 注册
    registerBtn() {
      let list = this.amountList.filter(item => item.selected == true)[0];
      let recharge_id = "";
      if (list) {
        recharge_id = list.id;
      }
      this.$axios({
        method: "post",
        url: this.$build + "/api/store/register",
        data: {
          store_id: this.storeId,
          password: this.password,
          key: this.smskey,
          code: this.code,
          recharge_id: null
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.member_order = res.data.data.order;
            sessionStorage.setItem("member_order", res.data.data.order);
            this.show = false;
            this.phone = "";
            this.password = "";
            this.code = "";
            this.payWrapper = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 会员充值
    RechargeBtn() {
      let list = this.amountList.filter(item => item.selected == true)[0];
      let recharge_id = "";
      if (list) {
        recharge_id = list.id;
      }
      if (recharge_id == "") {
        this.$toast({
          type: "fail",
          message: "请选择充值金额"
        });
      } else if (this.loginForm.phone == "") {
        this.$toast({
          type: "fail",
          message: "请登录会员"
        });
      } else {
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.code
          },
          url: this.$build + "/api/store/recharge",
          data: {
            store_id: this.storeId,
            phone: this.loginForm.phone,
            recharge_id: recharge_id
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.payType = "recharge";
              this.BalancePayShow = false;
              this.rechargeOrder = res.data.data.order;
              this.payMethod.forEach((item, index) => {
                console.log(item);
                if (item.name_en == "Cash") {
                  this.payMethod.splice(index, 1);
                } else if (item.name_en == "Voucher Payment") {
                  this.payMethod.splice(index, 1);
                } else if (item.name_en == "Balance Pay") {
                  this.payMethod.splice(index, 1);
                }
              });
              this.payWrapper = true;
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 获取可用支付方式
    getPayment() {
      this.$axios({
        method: "GET",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          if (res.data.status == 200) {
            sessionStorage.setItem("currency", res.data.data.currency.unit);
            sessionStorage.setItem("is_quick", res.data.data.is_quick);
            if (res.data.data.insite.length > 0) {
              this.payMethod = res.data.data.insite;
              this.payMethod.forEach((item, index) => {
                if (item.name_en == "Cash") {
                  this.payMethod.splice(index, 1);
                } else if (item.name_en == "Voucher Payment") {
                  this.payMethod.splice(index, 1);
                }
              });
              this.radio = res.data.data.insite[0].name_en;
            } else {
              this.payMethod = [];
              this.radio = "";
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 选择支付方式去支付
    goPay() {
      localStorage.setItem("orderLineType", "insite");
      if (this.radio == "Paypal") {
        console.log("Paypal支付");
        this.pay();
      } else if (this.radio == "Mypay") {
        console.log("Mypay支付");
        this.mypay();
      } else if (this.radio == "WeChat Pay") {
        console.log("微信支付");
        this.wxpay();
      } else if (this.radio == "Alipay") {
        console.log("支付宝支付");
        this.Alipay();
      } else if (this.radio == "Apple Pay") {
        console.log("Apple支付");
      } else if (this.radio == "Credit Card") {
        console.log("信用卡支付");
      } else if (this.radio == "Line Pay") {
        console.log("LinePay支付");
        this.linepay();
      } else if (this.radio == "Apple pay") {
        console.log("ApplePay支付");
        this.Applepay();
      } else if (this.radio == "Google pay") {
        console.log("GooglePay支付");
        this.googlepay();
      } else if (this.radio == "八达通") {
        console.log("八达通支付");
        this.badatong();
      } else if (this.radio == "ECpay" || this.radio == "EC Pay") {
        this.ECpay();
      }
    },
    // paypal支付
    pay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/paypal/pay",
        data: {
          order: this.rechargeOrder,
          code: sessionStorage.code
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            window.location.href = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // mypal支付
    mypay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/mypays/pay",
        data: {
          order: this.rechargeOrder,
          code: sessionStorage.code
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            window.location.href = res.data.data.url;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // linepay支付
    linepay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/line-pay/pay",
        data: {
          order: this.rechargeOrder
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.data.returnMessage
            });
            if (res.data.data.info) {
              setTimeout(() => {
                window.location.href = res.data.data.info.paymentUrl.web;
              }, 800);
            }
          } else {
            for (var item in res.data.error.message) {
              this.$toast({
                type: "fail",
                message: res.data.error.message[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 微信支付
    wxpay() {
      // return;
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/wechat/pay",
        data: {
          order: this.rechargeOrder
        }
      })
        .then(res => {
          console.log(res.data);
          if (res.status == 200) {
            this.$toast({
              type: "loading",
              message: ""
            });
            var s = res.data.replace(/<script>window.location.href="/, "");
            console.log(s);
            var c2 = s.substr(0, s.length - 10);
            console.log(c2);
            window.location.href = `${c2}`;
            this.$axios({
              method: "post",
              url: this.$build + "/api/wechat/notify",
              data: null
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  console.log(res.data);
                  this.$toast({
                    type: "success",
                    message: res.data.data.returnMessage
                  });
                } else {
                  for (var item in res.data.error.message) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error.message[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          } else {
            for (var item in res.data.error.message) {
              this.$toast({
                type: "fail",
                message: res.data.error.message[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 支付宝支付
    Alipay() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/alipay/pay",
        data: {
          order: this.rechargeOrder
        }
      })
        .then(res => {
          console.log(res.data);
          this.content = res.data;
          this.$toast({
            type: "loading",
            message: ""
          });
          setTimeout(() => {
            document.forms[0].submit(); //通过submit()传递给服务器，进行响应
            this.$axios({
              method: "post",
              url: this.$build + "/api/alipay/notify",
              data: null
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  console.log(res.data);
                  this.$toast({
                    type: "success",
                    message: res.data.data.returnMessage
                  });
                } else {
                  for (var item in res.data.error.message) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error.message[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          }, 100);
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // ECpay支付
    ECpay() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/ec-pay/pay",
        data: {
          order: this.rechargeOrder
        }
      }).then(res => {
        console.log(res);
        this.$toast({
          type: "loading",
          message: ""
        });
        window.location.href = res.data.data.url;
      });
    }
  }
};
</script>

<style scoped>
/deep/ .van-field .van-icon {
  font-size: 20px;
}
/deep/ .van-field__value {
  font-size: 16px;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-cell--large {
  align-items: center;
}
/deep/ .van-overlay {
  z-index: 2000 !important;
}
/deep/ .van-popup--bottom {
  z-index: 2001 !important;
}
/deep/ .van-popup--bottom .van-nav-bar .van-icon {
  color: #000 !important;
}
/deep/ .van-popup--bottom .van-nav-bar__title {
  color: #000 !important;
  font-size: 1.125rem;
  font-weight: 600;
}
/deep/ .van-field__left-icon {
  margin-right: 0.625rem;
}
.icon {
  font-size: 18px;
  margin-right: 4px;
  position: relative;
  top: 2px;
}
.main {
  margin: 0.625rem;
}
.header {
  text-align: right;
}
.card {
  background: rgb(74, 144, 226);
  color: #fff;
  padding: 1.25rem;
  margin: 0.625rem 0px;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-size: 18px;
}
.recharge_title {
  margin: 30px 10px 10px;
  font-size: 18px;
  font-weight: 600;
}
.recharge {
  margin: 0.625rem 0rem;
  display: flex;
  flex-wrap: wrap;
}
.recharge_card {
  width: calc(100% / 3.7);
  border: 1px solid #d4cece;
  border-radius: 10px;
  margin: 10px;
  color: #000;
  text-align: center;
  font-weight: 600;
}
.logs {
}
.footer {
  margin-top: 1.875rem;
}
.okBtn {
  width: 100%;
  padding: 1.5625rem;
}
.popup_hearder {
  margin: 0.625rem;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
.popup_content {
  width: 90%;
  margin: 0.625rem auto;
}
.popup_footer {
  margin: 1.25rem;
  text-align: center;
}
.loginBtn {
  width: 40%;
  font-size: 20px;
  font-weight: 600;
}
.cell {
  border: 1px solid #d4cece;
  border-radius: 5px;
  padding: 10px;
  margin: 10px;
}
.cell_content {
  display: flex;
  align-items: center;
}
.cell_left {
  width: calc(80% - 1.25rem);
}
.cell_right {
  width: 20%;
  margin-left: 1.25rem;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/member.vue